import { OptionItemsI } from 'interfaces';
import { create } from 'zustand';

interface OptionProps {
  option: OptionItemsI | null;
  setOption: (option: OptionItemsI | null) => void;
  isEdit: boolean;
  setIsEdit: (state: boolean) => void;
  idOptionEdit: number;
  setIdOptionEdit: (id: number) => void;

  isOpenModalOption: boolean;
  handleOpenModal: () => void;
  handleCloseModal: () => void;
}

export const useOptionsMenus = create<OptionProps>((set, get) => ({
  option: null,
  isEdit: false,
  idOptionEdit: 0,
  setOption: (option: OptionItemsI | null) => {
    set({ option: option });
  },
  setIsEdit: (state: boolean) => {
    set({ isEdit: state });
  },
  setIdOptionEdit: (id: number) => {
    set({ idOptionEdit: id });
  },
  isOpenModalOption: false,
  handleOpenModal: () => {
    set((state) => ({
      ...state,
      isOpenModalOption: !state.isOpenModalOption,
    }));
  },
  handleCloseModal: () => {
    set((state) => ({ ...state, isOpenModalOption: false }));
  },
}));
